import { forwardRef, LabelHTMLAttributes } from 'react';

export interface LabelProps
  extends Omit<LabelHTMLAttributes<HTMLLabelElement>, 'children'> {
  text: string | React.ReactNode;
  subtext?: string;
  for?: string;
  isTitle?: boolean;
  isLegend?: boolean;
}

const LabelElement = ({
  isTitle,
  text,
}: Pick<LabelProps, 'text' | 'isTitle'>) => {
  const normalLabel = (
    <p className={`text-text-body text-bodyLg font-bold`}>{text}</p>
  );
  const titleLabel = <h1 className={`text-brand-primary text-h2`}>{text}</h1>;
  return isTitle ? titleLabel : normalLabel;
};

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ subtext, text, isTitle, isLegend = false, ...props }, ref) => {
    const LabelContent = () => (
      <>
        <LabelElement isTitle={isTitle} text={text} />
        {subtext ? (
          <div className="text-body text-text-body">{subtext}</div>
        ) : null}
      </>
    );

    return isLegend ? (
      <legend>
        <LabelContent />
      </legend>
    ) : (
      <label {...props} ref={ref}>
        <LabelContent />
      </label>
    );
  },
);
Label.displayName = 'Label';
